import {useEffect, useMemo, useRef} from "react";
import {selectReleaseToggles, setReleaseToggles} from "../ReleaseToggles/releaseTogglesSlice";
import {useAppDispatch, useAppSelector} from "../store/hooks";
import {useAnalyticsTrackers} from 'src/utils/useAnalyticsTrackers';
import {useLocation} from "react-router-dom";
import * as releaseToggleClientApi from "../ReleaseToggles/ReleaseToggleApiClient";

const useAnalytics = (
    eventName: string,
    timeSpentEventName: string,
    featureFlag?: string,
    isAssetSummaryTimeSpentCall?: boolean
) => {
    const releaseToggles: any = useAppSelector(selectReleaseToggles);
    const location = useLocation();
    const openTimeRef = useRef<number | null>(null);
    const dispatch = useAppDispatch();

    const excludedPaths =
        useMemo(() => {
            return ['/Edit', '/LegalAgreementHoldings', '/PartiallyOwnedInvestmentAccountHoldings', '/HeldAwayAccountHoldings', '/Holdings'];
        }, []);




    const {track, page} = useAnalyticsTrackers(featureFlag);

    let releaseFlag: any = 'enableGoogleAnalytics';

    switch (true) {
        case location.pathname?.includes('/EstateFlowchart'):
            releaseFlag = 'enableDEFGoogleAnalytics';
            break;
        case location.pathname?.includes('/Agenda'):
            releaseFlag = 'enableAgendaGoogleAnalytics';
            break;
        case location.pathname?.includes('/Goals'):
            releaseFlag = 'enableGoalsGoogleAnalytics';
            break;
        default:
            releaseFlag = featureFlag ?? 'enableGoogleAnalytics';
    }

    const trackPageAnalytics = () => {
        if (isAssetSummaryTimeSpentCall === undefined || (isAssetSummaryTimeSpentCall === true && !excludedPaths.some(path => location.pathname?.includes(path)))) {
            page(eventName);
            track(eventName);
        }

        openTimeRef.current = window.performance.now();
    }

    useEffect(() => {
        if (releaseToggles?.[releaseFlag]) {
            trackPageAnalytics();
        } else if (!(releaseFlag in releaseToggles)) {
            releaseToggleClientApi.getLaunchDarklyFlag(releaseFlag)
                .then((flagValue) => {
                    dispatch(setReleaseToggles({...releaseToggles, [releaseFlag]: flagValue}));
                    if (flagValue) {
                        trackPageAnalytics();
                    }
                })
                .catch((error) => {
                    console.error(`Failed to retrieve ${releaseFlag}`, error.message);
                })
        }

        return () => {
            if (releaseToggles?.[releaseFlag] && openTimeRef.current) {
                const duration = Math.round((window.performance.now() - openTimeRef.current) / 1000);
                if (isAssetSummaryTimeSpentCall === undefined || (isAssetSummaryTimeSpentCall === true && !excludedPaths.some(path => location.pathname?.includes(path))))
                {
                    page(timeSpentEventName, {cd4_duration: duration});
                    track(timeSpentEventName, {cd4_duration: duration});
                }
                console.log("Time spent on page:", duration, "seconds");
            }
            openTimeRef.current = null
        };


    }, [location.pathname]);
};

export default useAnalytics;